import { ReactNode, useEffect, useState, useRef } from "react";
import { Routes, Route, useLocation, useNavigate, Navigate } from "react-router-dom";
import logAnalyticsEvent from "../../services/AnalyticsManager/AnalyticsManager";
import { GGAnalyticsEvents } from "../../services/AnalyticsManager/GGAnalyticsEvents";
import io from "socket.io-client";
import { DashboardSideNav } from "../../components/PageComponents/SellerDashboardComponents/DashboardSideNav/DashboardSideNav";
import { DashboardOverview } from "../../components/PageComponents/SellerDashboardComponents/DashboardSections/DashboardOverview";
import { WorkspacePanel } from "../../components/PageComponents/SellerDashboardComponents/DashboardSections/WorkspacePanel";
import { MessagesPanel } from "../../components/PageComponents/SellerDashboardComponents/DashboardSections/MessagesPanel";
import { MyGigsPanel } from "../../components/PageComponents/SellerDashboardComponents/DashboardSections/MyGigsPanel";
import { OrdersPanel } from "../../components/PageComponents/SellerDashboardComponents/DashboardSections/OrdersPanel";
import { SettingsPanel } from "../../components/PageComponents/SellerDashboardComponents/DashboardSections/SettingsPanel";
import { HelpPanel } from "../../components/PageComponents/SellerDashboardComponents/DashboardSections/HelpPanel";
import './FreelancerDashboard.scss';
import { Avatar, Box, IconButton, Typography, Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { SessionManager } from "../../services/SessionManager/SessionManager";
import { Buyer } from "../../Models/Buyer";
import { SellerAPIHandler } from "../../services/NetworkClient/BackendAPIs/SellerAPIhandler";
import { SellerInterface } from "../../Models/Seller";
import { BuyerAPIHandler } from "../../services/NetworkClient/BackendAPIs/BuyerAPIHandler";
import { SellerPlanDetailsModal } from "../../components/PageComponents/SellerDashboardComponents/SellerPlanDetailsModal/SellerPlanDetailsModal";
import Skeleton from '@mui/material/Skeleton';
import SpaceDashboardOutlinedIcon from '@mui/icons-material/SpaceDashboardOutlined';
import SpaceDashboardRoundedIcon from '@mui/icons-material/SpaceDashboardRounded';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import ChatBubbleRoundedIcon from '@mui/icons-material/ChatBubbleRounded';
import FeaturedPlayListOutlinedIcon from '@mui/icons-material/FeaturedPlayListOutlined';
import FeaturedPlayListRoundedIcon from '@mui/icons-material/FeaturedPlayListRounded';
import WorkspacesOutlinedIcon from '@mui/icons-material/WorkspacesOutlined';
import WorkspacesRoundedIcon from '@mui/icons-material/WorkspacesRounded';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import ShoppingCartRoundedIcon from '@mui/icons-material/ShoppingCartRounded';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import HelpRoundedIcon from '@mui/icons-material/HelpRounded';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import NotificationsNoneRoundedIcon from '@mui/icons-material/NotificationsNoneRounded';
import Badge from '@mui/material/Badge';
import GGButton from "../../components/CommonComponents/GGButton/GGButton";
import { DashboardNavigationProvider, useDashboardNavigation } from "../../contexts/DashboardNavigationContext";
import { useDispatch, useSelector } from "react-redux";
import { logout as logoutAction } from "../../redux/auth/authSlice";
import { NotificationAPIHandler } from "../../services/NetworkClient/BackendAPIs/NotificationAPIHandler";
import { NotificationInterface } from "../../Models/Notification";
import { ServerConfig } from "../../services/NetworkClient/ServerConfig";
import { RootState } from "../../redux/store";
import { resetPanelClosed, triggerNewNotification } from "../../components/PageComponents/NotificationWindow/NotificationSlice";
import NotificationDropdown from "../../components/CommonComponents/Navbar/components/shared/NotificationDropdown";
import NotificationPanel from "../../components/PageComponents/NotificationWindow/NotificationPanel/NotificationPanel";
import { SnackTypes } from "../../components/UtilityComponents/SnackBar/SnackBar";
import SnackBar from "../../components/UtilityComponents/SnackBar/SnackBar";
import { GigAPIHandler } from "../../services/NetworkClient/BackendAPIs/GigAPIHandler";
import GGModalWindow from "../../components/UtilityComponents/GGModalWindow/GGModalWindow";
import { ErrorLogger } from "../../utils/Logger";

const SOCKET_RECONNECT_DELAY_MS = 2000;


enum DashboardSectionKey {
    DASHBOARD = 'dashboard',
    WORKSPACE = 'workspace',
    MESSAGES = 'messages',
    GIGS = 'gigs',
    ORDERS = 'orders',
    SETTINGS = 'settings',
    HELP = 'help',
    LOGOUT = 'logout',
}

enum DashboardSectionTitle {
    DASHBOARD = 'Dashboard',
    WORKSPACE = 'Workspace',
    MESSAGES = 'Messages',
    GIGS = 'My Gigs',
    ORDERS = 'Orders',
    SETTINGS = 'Settings',
    HELP = 'Help',
    LOGOUT = 'Logout',
}

type DashboardMenuItem = {
    key: DashboardSectionKey;
    label: DashboardSectionTitle;
    outlinedIcon: ReactNode;
    roundedIcon: ReactNode;
    type: 'primary' | 'secondary';
};

const dashboardMenuItems: DashboardMenuItem[] = [
    { key: DashboardSectionKey.DASHBOARD, label: DashboardSectionTitle.DASHBOARD, type: 'primary',   outlinedIcon: <SpaceDashboardOutlinedIcon />,    roundedIcon: <SpaceDashboardRoundedIcon /> },
    { key: DashboardSectionKey.WORKSPACE, label: DashboardSectionTitle.WORKSPACE, type: 'primary',   outlinedIcon: <WorkspacesOutlinedIcon />,        roundedIcon: <WorkspacesRoundedIcon /> },
    { key: DashboardSectionKey.MESSAGES,  label: DashboardSectionTitle.MESSAGES,  type: 'primary',   outlinedIcon: <ChatBubbleOutlineOutlinedIcon />, roundedIcon: <ChatBubbleRoundedIcon /> },
    { key: DashboardSectionKey.GIGS,      label: DashboardSectionTitle.GIGS,      type: 'primary',   outlinedIcon: <FeaturedPlayListOutlinedIcon />,  roundedIcon: <FeaturedPlayListRoundedIcon /> },
    { key: DashboardSectionKey.ORDERS,    label: DashboardSectionTitle.ORDERS,    type: 'primary',   outlinedIcon: <ShoppingCartOutlinedIcon />,      roundedIcon: <ShoppingCartRoundedIcon /> },
    { key: DashboardSectionKey.SETTINGS,  label: DashboardSectionTitle.SETTINGS,  type: 'secondary', outlinedIcon: <SettingsOutlinedIcon />,          roundedIcon: <SettingsRoundedIcon /> },
    { key: DashboardSectionKey.HELP,      label: DashboardSectionTitle.HELP,      type: 'secondary', outlinedIcon: <HelpOutlineOutlinedIcon />,       roundedIcon: <HelpRoundedIcon /> },
    // { key: DashboardSectionKey.LOGOUT,    label: DashboardSectionTitle.LOGOUT,    type: 'secondary', outlinedIcon: <LogoutRoundedIcon />,             roundedIcon: <LogoutRoundedIcon /> },
];

// Helper function to get title from pathname
const getTitleForPath = (pathname: string): string => {
    // Extract the section from pathname
    const pathParts = pathname.split('/').filter(Boolean);
    
    // Handle base dashboard route
    if (pathname === '/freelancer-dashboard' || pathname === '/freelancer-dashboard/') {
        return DashboardSectionTitle.DASHBOARD;
    }

    // Handle sub-routes
    if (pathParts.length >= 2) {
        const section = pathParts[1];
        
        // Handle nested routes like /my-gigs/edit/:id
        if (section === 'my-gigs') {
            if (pathParts[2] === 'edit' && pathParts[3]) {
                return 'Edit Gig';
            }
            if (pathParts[2] === 'add-new-gig') {
                return 'Add New Gig';
            }
            return DashboardSectionTitle.GIGS;
        }
        
        if (section === 'settings') {
            if (pathParts[2] === 'profile') {
                return 'Profile Settings';
            }
            if (pathParts[2] === 'password') {
                return 'Password Settings';
            }
            return DashboardSectionTitle.SETTINGS;
        }
        
        // Map section to title
        const sectionMap: Record<string, DashboardSectionTitle> = {
            'dashboard': DashboardSectionTitle.DASHBOARD,
            'workspace': DashboardSectionTitle.WORKSPACE,
            'messages': DashboardSectionTitle.MESSAGES,
            'gigs': DashboardSectionTitle.GIGS,
            'orders': DashboardSectionTitle.ORDERS,
            'settings': DashboardSectionTitle.SETTINGS,
            'help': DashboardSectionTitle.HELP,
        };
        
        return sectionMap[section] || DashboardSectionTitle.DASHBOARD;
    }
    
    return DashboardSectionTitle.DASHBOARD;
};

// Helper function to get active section from pathname
const getActiveSectionFromPath = (pathname: string): DashboardSectionKey => {
    const pathParts = pathname.split('/').filter(Boolean);
    
    if (pathParts.length >= 2) {
        const section = pathParts[1];
        const sectionMap: Record<string, DashboardSectionKey> = {
            'dashboard': DashboardSectionKey.DASHBOARD,
            'workspace': DashboardSectionKey.WORKSPACE,
            'messages': DashboardSectionKey.MESSAGES,
            'my-gigs': DashboardSectionKey.GIGS,
            'gigs': DashboardSectionKey.GIGS,
            'orders': DashboardSectionKey.ORDERS,
            'settings': DashboardSectionKey.SETTINGS,
            'help': DashboardSectionKey.HELP,
        };
        return sectionMap[section] || DashboardSectionKey.DASHBOARD;
    }
    
    return DashboardSectionKey.DASHBOARD;
};

// Inner component that uses the navigation context
const FreelancerDashboardContent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { canGoBack, goBack, getCurrentTitle } = useDashboardNavigation();
    const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
    const [isNavCollapsed, setIsNavCollapsed] = useState(false);
    const [seller, setSeller] = useState<SellerInterface>();
    const [showFirstGigModal, setShowFirstGigModal] = useState(false);
    const [showPlanModal, setShowPlanModal] = useState(false);
    const [profileMenuAnchor, setProfileMenuAnchor] = useState<null | HTMLElement>(null);
    const [notificationMenuAnchor, setNotificationMenuAnchor] = useState<null | HTMLElement>(null);
    const [navbarTopFiveNotifications, setNavbarTopFiveNotifications] = useState<NotificationInterface[]>([]);
    const [unreadNotificationCount, setUnreadNotificationCount] = useState<number>(0);
    const [openNotificationPanel, setOpenNotificationPanel] = useState(false);
    const [currentUserId, setCurrentUserId] = useState<string>();
    
    const snackBarRef = useRef<{ showSnackbar(): any }>(null);
    const [snackBarParams, setSnackBarParams] = useState({
        message: "",
        state: SnackTypes.error
    });
    
    const panelClosed = useSelector((state: RootState) => state.notification.panelClosed);
    
    const activeSection = getActiveSectionFromPath(location.pathname);

    useEffect(() => {
        document.title = "GenieGig | Dashboard";
        logAnalyticsEvent(GGAnalyticsEvents.SELLER_DASHBOARD_PAGE_LOADED);
    }, []);

    // Update notifications for dashboard
    const updateNotificationForDashboard = async () => {
        try {
            const notificationsForNavBar = await NotificationAPIHandler.shared.getNavbarNotifications();
            setUnreadNotificationCount(notificationsForNavBar.totalUnreadCount);
            setNavbarTopFiveNotifications(notificationsForNavBar.unreadNotifications);
        } catch (error) {
            ErrorLogger.log(error, 'NewFreelancerDashboard.updateNotificationForDashboard');
        }
    };

    // Snackbar handler
    const showSnackbar = (message: string, state: SnackTypes) => {
        setSnackBarParams({ message: message, state: state });
        snackBarRef.current?.showSnackbar();
    };

    // Setup socket connection for real-time notifications, returns a cleanup function
    const setupSocketConnection = (userId: string) => {
        if (!SessionManager.shared.fetchJWTToken()) return undefined;

        const socket = io(ServerConfig.shared.baseDomainName, {
            // Read per attempt so reconnects always send the current token.
            auth: (sendAuth: (data: object) => void) =>
                sendAuth({ token: SessionManager.shared.fetchJWTToken() })
        });

        const handleNewNotification = (notification: NotificationInterface) => {
            showSnackbar(`New Notification: ${notification.title}`, SnackTypes.info);

            const notificationSound = new Audio('/assets/sounds/gg_notification_default.mp3');
            notificationSound.play().catch(() => {});

            dispatch(triggerNewNotification());
            updateNotificationForDashboard();
        };

        // Server derives the room from the token, subscribe is kept for backwards compatibility
        socket.on('connect', () => {
            socket.emit('subscribe', userId);
        });

        socket.on('new-notification', handleNewNotification);

        socket.on('connect_error', (error) => {
            ErrorLogger.log(error, 'NewFreelancerDashboard.notificationSocket');
        });

        // socket.io never retries a server-initiated disconnect, so without this the
        // socket stays silently dead and no notification ever arrives again.
        let reconnectTimer: number | undefined;
        const handleDisconnect = (reason: string) => {
            if (reason !== 'io server disconnect') return;
            if (!SessionManager.shared.fetchJWTToken()) return;
            reconnectTimer = window.setTimeout(() => socket.connect(), SOCKET_RECONNECT_DELAY_MS);
        };

        socket.on('disconnect', handleDisconnect);

        return () => {
            window.clearTimeout(reconnectTimer);
            socket.off('new-notification', handleNewNotification);
            socket.off('disconnect', handleDisconnect);
            socket.disconnect();
        };
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                let buyer = SessionManager.shared.buyer as Buyer;
                if (buyer === undefined) {
                    buyer = await BuyerAPIHandler.shared.getBuyerByAuthToken();
                }
                SessionManager.shared.buyer = buyer;

                try {
                    const seller = await SellerAPIHandler.shared.getSellerByAuthId();
                    await handleNewSellerPopup(seller.id);
                    setSeller(seller);
                } catch (err) {
                    ErrorLogger.log(err, 'NewFreelancerDashboard.fetchData');
                }

                // Setup notifications
                setCurrentUserId(buyer.id);
                updateNotificationForDashboard();
            } catch (err) {
                ErrorLogger.log(err, 'NewFreelancerDashboard.getBuyerByAuthToken');
            }
        };

        fetchData();
        // eslint-disable-next-line
    }, []);

    // Notification socket, recreated whenever the session changes
    useEffect(() => {
        if (!currentUserId) return;

        const cleanupSocket = setupSocketConnection(currentUserId);
        return () => {
            cleanupSocket?.();
        };
        // eslint-disable-next-line
    }, [currentUserId]);

    // Handle panel closed state
    useEffect(() => {
        if (panelClosed) {
            updateNotificationForDashboard();
            dispatch(resetPanelClosed());
        }
        // eslint-disable-next-line 
    }, [panelClosed]);

    const handleNavSelection = (key: DashboardSectionKey) => {
        // Navigate to the section route (relative paths since we're inside /freelancer-dashboard/*)
        const routeMap: Record<DashboardSectionKey, string> = {
            [DashboardSectionKey.DASHBOARD]: '/freelancer-dashboard/dashboard',
            [DashboardSectionKey.WORKSPACE]: '/freelancer-dashboard/workspace',
            [DashboardSectionKey.MESSAGES]: '/freelancer-dashboard/messages',
            [DashboardSectionKey.GIGS]: '/freelancer-dashboard/my-gigs',
            [DashboardSectionKey.ORDERS]: '/freelancer-dashboard/orders',
            [DashboardSectionKey.SETTINGS]: '/freelancer-dashboard/settings',
            [DashboardSectionKey.HELP]: '/freelancer-dashboard/help',
            [DashboardSectionKey.LOGOUT]: '/freelancer-dashboard',
        };
        
        navigate(routeMap[key] || '/freelancer-dashboard/dashboard');
        setIsMobileNavOpen(false);
    };

    const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setProfileMenuAnchor(event.currentTarget);
    };

    const handleProfileMenuClose = () => {
        setProfileMenuAnchor(null);
    };

    const handleManageProfile = () => {
        handleProfileMenuClose();
        navigate('/my-profile');
    };

    const handleContactUs = () => {
        handleProfileMenuClose();
        navigate('/contact-us');
    };

    const handleLogout = () => {
        handleProfileMenuClose();
        SessionManager.shared.signOut();
        dispatch(logoutAction());
        navigate('/');
    };

    const handleNotificationMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setNotificationMenuAnchor(event.currentTarget);
    };

    const handleNotificationMenuClose = () => {
        setNotificationMenuAnchor(null);
    };

    const handleNotificationClick = () => {
        handleNotificationMenuClose();
        setOpenNotificationPanel(true);
    };

    const handleNavigateToMyGigs = () => {
        setShowFirstGigModal(false);
        navigate("/freelancer-dashboard/my-gigs");
    };

    const handleNewSellerPopup = async (sellerId: string) => {
        const gigs = await GigAPIHandler.shared.getGigsBySeller(sellerId);
        if (gigs.length === 0) {
            setShowFirstGigModal(true);
        }
    };

    const handlePlanBoxClick = () => {
        if (!seller?.planDetails?.plan) return;
        setShowPlanModal(true);
    };

    // Map items to include the correct icon based on active state
    const itemsWithActiveIcons = dashboardMenuItems.map(item => ({
        key: item.key,
        label: item.label,
        icon: activeSection === item.key ? item.roundedIcon : item.outlinedIcon,
        type: item.type,
    }));

    return (
        <div className="new-seller-dashboard-container">
            <aside
                id="seller-dashboard-side-nav"
                className={`new-seller-dashboard-side-nav-container ${isMobileNavOpen ? 'open' : ''} ${isNavCollapsed ? 'collapsed' : ''}`}
            >
                <DashboardSideNav
                    items={itemsWithActiveIcons}
                    activeItem={activeSection}
                    onSelect={handleNavSelection}
                    seller={seller}
                    onProfileMenuOpen={handleProfileMenuOpen}
                    isCollapsed={isNavCollapsed}
                    onToggleCollapse={() => setIsNavCollapsed(prev => !prev)}
                    onPlanBoxClick={handlePlanBoxClick}
                />
                {/* Collapse toggle button - positioned relative to parent container */}
                <IconButton
                    className="nav-collapse-toggle-button"
                    onClick={() => setIsNavCollapsed(prev => !prev)}
                    aria-label={isNavCollapsed ? "Expand navigation" : "Collapse navigation"}
                    aria-expanded={!isNavCollapsed}
                >
                    {isNavCollapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                </IconButton>
            </aside>

            {isMobileNavOpen && (
                <button
                    type="button"
                    className="mobile-nav-backdrop"
                    aria-label="Close navigation"
                    onClick={() => setIsMobileNavOpen(false)}
                />
            )}

            <main className="new-seller-dashboard-content">
                <div className="dashboard-header">
                    <div className="header-title-container">
                        {/* Desktop back button */}
                        {canGoBack && (
                            <IconButton 
                                className="header-back-button" 
                                onClick={goBack}
                                aria-label="Go back"
                            >
                                <ArrowBackIcon />
                            </IconButton>
                        )}
                        {/* Mobile hamburger menu */}
                        {!canGoBack && (
                            <IconButton 
                                className="mobile-menu-toggle" 
                                onClick={() => setIsMobileNavOpen((open) => !open)}
                                aria-expanded={isMobileNavOpen}
                                aria-controls="seller-dashboard-side-nav"
                                aria-label="Toggle navigation menu"
                            >
                                <MenuIcon />
                            </IconButton>
                        )}
                        {/* Mobile back button */}
                        {canGoBack && (
                            <IconButton 
                                className="mobile-back-button" 
                                onClick={goBack}
                                aria-label="Go back"
                            >
                                <ArrowBackIcon />
                            </IconButton>
                        )}
                        <Typography className="header-title">
                            {getCurrentTitle()}
                        </Typography>
                    </div>
                    <div className="header-actions">

                        <IconButton 
                            className="icon-button notification-button" 
                            onClick={handleNotificationMenuOpen}
                            aria-label="Notifications"
                        >
                            <Badge badgeContent={unreadNotificationCount > 0 ? unreadNotificationCount : 0} color="error">
                                <NotificationsNoneRoundedIcon />
                            </Badge>
                        </IconButton>
                        <Menu
                            anchorEl={notificationMenuAnchor}
                            open={Boolean(notificationMenuAnchor)}
                            onClose={handleNotificationMenuClose}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            PaperProps={{
                                className: "notification-menu",
                                sx: {
                                    mt: 0.5,
                                    minWidth: 320,
                                    maxWidth: 400,
                                    maxHeight: 500,
                                    boxShadow: '0px 0px 12px rgba(0, 0, 0, 0.15)',
                                    borderRadius: '8px',
                                }
                            }}
                        >
                            <div className="notification-menu-content">
                                {navbarTopFiveNotifications.length > 0 ? (
                                    <NotificationDropdown
                                        notifications={navbarTopFiveNotifications}
                                        unreadCount={unreadNotificationCount}
                                        onNotificationClick={handleNotificationClick}
                                    />
                                ) : (
                                    <div className="no-notifications">
                                        <Typography variant="body2" sx={{ textAlign: 'center', color: '#666' }} component="div">
                                            <NotificationsNoneRoundedIcon fontSize="small" />
                                            <span>No new notifications</span>
                                        </Typography>
                                    </div>
                                )}
                            </div>
                        </Menu>
                        
                        <div className="vertical-divider"></div>

                        <GGButton 
                            disableClickShrink={true} 
                            type="button" 
                            className="user-profile" 
                            aria-label="User profile menu"
                            onClick={handleProfileMenuOpen}
                        >
                            <div className="user-profile-box-avatar">
                                {seller?.profileImage ? (
                                    <Avatar src={seller.profileImage} alt="User Profile" sx={{ width: 40, height: 40 }} />
                                ) : (
                                    <Skeleton variant="circular" animation="wave" sx={{ width: 40, height: 40 }} />
                                )}
                            </div>
                            <Typography className="user-profile-box-name">
                                {seller?.fullName || "Loading..."}
                            </Typography>
                            <KeyboardArrowDownIcon className="user-profile-dropdown-icon" />
                        </GGButton>
                        
                        <Menu
                            anchorEl={profileMenuAnchor}
                            open={Boolean(profileMenuAnchor)}
                            onClose={handleProfileMenuClose}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            PaperProps={{
                                className: "profile-menu",
                                sx: {
                                    mt: 0,
                                    minWidth: 200,
                                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                                    borderRadius: '8px',
                                }
                            }}
                        >
                            <MenuItem className="profile-menu-item" onClick={handleManageProfile}>
                                <ListItemIcon>
                                    <AccountCircleOutlinedIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText>Manage Profile</ListItemText>
                            </MenuItem>
                            <MenuItem className="profile-menu-item" onClick={handleContactUs}>
                                <ListItemIcon>
                                    <SupportAgentIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText>Contact Us</ListItemText>
                            </MenuItem>
                            <MenuItem className="profile-menu-item" onClick={handleLogout}>
                                <ListItemIcon>
                                    <LogoutRoundedIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText>Logout</ListItemText>
                            </MenuItem>
                        </Menu>
                    </div>
                </div>
                <SnackBar ref={snackBarRef} severity={snackBarParams.state} alertDuration={5000} message={snackBarParams.message} />
                <NotificationPanel openPanel={openNotificationPanel} setOpenPanel={setOpenNotificationPanel} />
                
                {/* Seller Plan Details Modal */}
                {seller?.planDetails && (
                    <GGModalWindow
                        open={showPlanModal}
                        onCloseHandler={() => setShowPlanModal(false)}
                        title="Your Plan Details"
                        width="600px"
                        childView={<SellerPlanDetailsModal planDetails={seller.planDetails} />}
                    />
                )}

                <GGModalWindow
                    open={showFirstGigModal}
                    onCloseHandler={() => setShowFirstGigModal(false)}
                    title="Start Your Journey"
                    width="400px"
                    childView={
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                textAlign: 'center',
                                padding: '20px 0',
                            }}
                        >
                            <AddCircleOutlineIcon
                                sx={{
                                    fontSize: 64,
                                    color: '#1976d2',
                                    marginBottom: '16px',
                                }}
                            />
                            <Typography
                                variant="h6"
                                sx={{
                                    fontWeight: 600,
                                    marginBottom: '12px',
                                    color: '#333',
                                }}
                            >
                                Create Your First Gig
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{
                                    color: '#666',
                                    lineHeight: 1.6,
                                    maxWidth: '300px',
                                    marginBottom: '24px',
                                }}
                            >
                                Ready to start freelancing? Create your first gig and begin your journey as a freelancer on GenieGig.
                            </Typography>
                            <GGButton
                                variant="outlined"
                                onClick={handleNavigateToMyGigs}
                                sx={{
                                    color: '#1976d2',
                                    padding: '12px 24px',
                                    borderRadius: '8px',
                                    textTransform: 'none',
                                    fontSize: '16px',
                                    fontWeight: 600,
                                }}
                            >
                                Go to My Gigs
                            </GGButton>
                        </Box>
                    }
                />
                <div className="dashboard-content-scrollable">
                    <div key={location.key} className="dashboard-content-wrapper">
                        <Routes location={location}>
                            <Route index element={<Navigate to="dashboard" replace />} />
                            <Route path="dashboard" element={<DashboardOverview />} />
                            <Route path="workspace" element={<WorkspacePanel />} />
                            <Route path="messages/*" element={<MessagesPanel />} />
                            <Route path="my-gigs/*" element={<MyGigsPanel />} />
                            <Route path="orders" element={<OrdersPanel />} />
                            <Route path="settings/*" element={<SettingsPanel />} />
                            <Route path="help" element={<HelpPanel />} />
                            <Route path="*" element={<Navigate to="dashboard" replace />} />
                        </Routes>
                    </div>
                </div>
            </main>
        </div>
    );
};

export const FreelancerDashboard = () => {
    return (
        <DashboardNavigationProvider getTitleForPath={getTitleForPath}>
            <FreelancerDashboardContent />
        </DashboardNavigationProvider>
    );
};